// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fb-permission-modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 1.5rem;
}

.fb-permission-modal-title {
  font-size: 1.8rem;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.fb-permission-warning-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #fff3e0;
  border-radius: 10px;
  padding: 14px;
  line-height: 1.45;
  border-left: 5px solid #ff9800;
  margin-bottom: 1.5rem;
}

.fb-permission-warning-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.fb-permission-warning-box p {
  margin: 0;
  color: #555;
  font-size: 0.95rem;
}

.fb-permission-warning-icon {
  font-size: 28px;
  color: #ff9800;
  flex-shrink: 0;
}

.fb-permission-steps {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
}

.fb-permission-steps-title {
  font-size: 1.2rem;
  color: #333;
  margin-top: 0;
  margin-bottom: 1rem;
  font-weight: 600;
}

.fb-permission-steps-list {
  margin: 0;
  padding-left: 1rem;
  color: #555;
}

.fb-permission-steps-list li {
  margin-bottom: 1rem;
  line-height: 1.6;
  font-size: 0.95rem;
}

.fb-permission-steps-list li:last-child {
  margin-bottom: 0;
}

.fb-permission-final-step {
  background-color: #f3eaff;
  padding: 12px;
  border-radius: 8px;
  border-left: 4px solid #5616ea;
  margin-top: 0.5rem !important;
  list-style: none;
  margin-left: -1rem;
  display: flex;
  align-items: center;
  gap: 10px;
}

.fb-permission-arrow-icon {
  color: #5616ea;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.fb-permission-final-step strong {
  color: #5616ea;
}

.fb-permission-steps-list a {
  color: #5616ea;
  text-decoration: none;
  font-weight: 600;
}

.fb-permission-steps-list a:hover {
  text-decoration: underline;
}

.fb-permission-steps-list strong {
  font-weight: 600;
  color: #333;
}

.fb-permission-modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1.5rem;
}

@media (max-width: 768px) {
  .fb-permission-modal-title {
    font-size: 1.5rem;
  }

  .fb-permission-steps {
    padding: 1rem;
  }

  .fb-permission-steps-title {
    font-size: 1.1rem;
  }

  .fb-permission-steps-list {
    padding-left: 1.2rem;
  }

  .fb-permission-steps-list li {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FacebookPermissionModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".fb-permission-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.fb-permission-modal-title {\r\n  font-size: 1.8rem;\r\n  color: #333;\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.fb-permission-warning-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #fff3e0;\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #ff9800;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.fb-permission-warning-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.fb-permission-warning-box p {\r\n  margin: 0;\r\n  color: #555;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.fb-permission-warning-icon {\r\n  font-size: 28px;\r\n  color: #ff9800;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fb-permission-steps {\r\n  background-color: #f8f9fa;\r\n  border-radius: 10px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.fb-permission-steps-title {\r\n  font-size: 1.2rem;\r\n  color: #333;\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.fb-permission-steps-list {\r\n  margin: 0;\r\n  padding-left: 1rem;\r\n  color: #555;\r\n}\r\n\r\n.fb-permission-steps-list li {\r\n  margin-bottom: 1rem;\r\n  line-height: 1.6;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.fb-permission-steps-list li:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.fb-permission-final-step {\r\n  background-color: #f3eaff;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  border-left: 4px solid #5616ea;\r\n  margin-top: 0.5rem !important;\r\n  list-style: none;\r\n  margin-left: -1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.fb-permission-arrow-icon {\r\n  color: #5616ea;\r\n  font-size: 1.1rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fb-permission-final-step strong {\r\n  color: #5616ea;\r\n}\r\n\r\n.fb-permission-steps-list a {\r\n  color: #5616ea;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.fb-permission-steps-list a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.fb-permission-steps-list strong {\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n.fb-permission-modal-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: center;\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .fb-permission-modal-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .fb-permission-steps {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .fb-permission-steps-title {\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .fb-permission-steps-list {\r\n    padding-left: 1.2rem;\r\n  }\r\n\r\n  .fb-permission-steps-list li {\r\n    font-size: 0.9rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
